export default __webpack_public_path__ + "static/media/client3.cf89904b.svg";